const countries:Country[] = require('../../../../../utils/iso3166/output/countries.min.json')

// these property names need to match values of ageRequirementType in campaign
interface MinAge {
   spirit:number;
   wine:number;
   auto:number;
}

export interface State {
   name:string;
   code:string;
   minAge:MinAge;
}

export interface Country {
   name:string;
   code:string;
   minAge:MinAge;
   postalRegex:string;
   states:State[];
}

export function browserCountry() {
   if (navigator.language && navigator.language.length >= 5) {
      return navigator.language.slice(-2).toUpperCase();
   }
}

export default countries;
